import Logo from "./Dentin_-_Logo.bc5c134eab6a76cba456-removebg-preview.png";
import Den from "./dentin_logos-removebg-preview.png";
import Docter from "./docter.png";
import Benifit from "./young-female-patient-with-open-mouth-examining-dental-inspection-dentist-office_496169-976.jpg";
import Benifit1 from "./dentist-with-smile_144627-886.avif";
import client1 from "./client1.jpg";
import client2 from "./Clint2.jpg";
import client3 from "./client3.jpg";
import client4 from "./client4.avif";
import client5 from "./clinnts5.avif";
import client6 from "./clinet6.avif";
import invi1 from "./invi1.jpg";
import invi2 from "./invisling2.avif";
import invi3 from "./invi4.avif";
import img1 from "./gallery/img1.jpg";
import img2 from "./gallery/img2.jpg";
import img3 from "./gallery/img3.jpg";
import img4 from "./gallery/img4.jpg";
import img5 from "./gallery/img5.jpg";
import img6 from "./gallery/img6.jpg";
import img7 from "./gallery/img7.jpg";
import img8 from "./gallery/img8.jpg";
import img9 from "./gallery/img9.jpg";
import img10 from "./gallery/img10.jpg";
import img11 from "./gallery/img11.jpg";
import img12 from "./gallery/img12.jpg";
import img13 from "./gallery/img13.jpg";
import img14 from "./gallery/img14.jpg";
import img15 from "./gallery/img15.jpg";
import img16 from "./gallery/img16.jpg";
import img17 from "./gallery/img17.jpg";
import img18 from "./gallery/img18.jpg";
import img19 from "./gallery/img19.jpg";
import img20 from "./gallery/img20.jpg";
import img21 from "./gallery/img21.jpg";
import img22 from "./gallery/img22.jpg";
import img23 from "./gallery/img23.jpg";
import img24 from "./gallery/img24.jpg";
import video1 from "./videos/video1.mp4";
import video2 from "./videos/video2.mp4";
import video3 from "./videos/video3.mp4";
import video4 from "./videos/video4.mp4";
import aboutimg from "./aboutimg.jpg";
import TeethWhitening from "./DeopDownimg/teethwhiting.avif";
import DentalImplants from "./DeopDownimg/Dental-implants.avif";
import DenturesBridges from "./DeopDownimg/Dentures & Bridges.avif";
import FillingandSealants from "./DeopDownimg/Filling and Sealants.avif";
import OralSurgery from "./DeopDownimg/Oral Surgery.avif";
import RootCanals from "./DeopDownimg/Root Canals.avif";
import LaserDentistry from "./DeopDownimg/Laser Dentistry.avif";
import TeethReshaping from "./DeopDownimg/Teeth Reshaping.avif";
import contentus from "./contentus.jpg"
import review1 from "./review1.png" 
import  review2 from "./review2.png" 
import review3 from "./review3.png" 
import review4 from "./review4.png" 
import review5 from "./review5.png" 
import review6 from "./review6.png" 
import review7 from "./review7.png"
import bgimg from "./bgimg.avif"
import Dentin from "./logo for dentin.jpg"
import invilogo from "./invisalign-logo.webp"


export const assest = {
  Logo,
  Den,
  Docter,
  Benifit,
  Benifit1,
  client1,
  client2,
  client3,
  client4,
  client5,
  client6,
  invi1,
  invi2,
  invi3,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  video1,
  video2,
  video3,
  video4,
  aboutimg,
  TeethWhitening,
  DentalImplants,
  DenturesBridges,
  FillingandSealants,
  OralSurgery,
  RootCanals,
  LaserDentistry,
  TeethReshaping,
  contentus,
  review1,
  review2,
  review3,
  review4,
  review5,
  review6,
  review7,
  bgimg,
  Dentin,
  invilogo

};
